import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable, InjectionToken } from '@angular/core';
import { environment } from '@quorum/environments';
import { ResponseInterceptorOptions as ApiResponseHeaders } from '@quorum/models/xs-misc';
import { Observable, ReplaySubject, throwError } from 'rxjs';
import { catchError, filter, map, switchMap, take } from 'rxjs/operators';
import { Business, BusinessQueryParameters } from '@quorum/models/aws';
export const QUORUM_API_BASE = new InjectionToken('QUORUM_API_BASE');
@Injectable()
export class OemMenuService {
  //businessId: string;
  businessId$: ReplaySubject<string> = new ReplaySubject(1);
  constructor(private http: HttpClient, @Inject(QUORUM_API_BASE) public quorumApiBase: string) {}

  initialize(destinationId: string) {
    const businessObject: BusinessQueryParameters = new BusinessQueryParameters({ destinationId: destinationId });
    const businessQueryParameter = new HttpParams({ fromObject: { ...businessObject } });
    this.http
      .get<Business[]>(`https://${determineEnvironment()}${this.quorumApiBase}/businesses`, {
        params: businessQueryParameter,
      })
      .subscribe(
        (businessList) => {
          if (businessList && businessList.length > 0 && businessList[0].id != null) {
            this.businessId$.next(businessList[0].id);
          } else {
            // businessId$ is a ReplaySubject — calling .error() would terminate
            // it for every downstream subscriber for the rest of the session.
            // Log and leave the subject idle; consumers already gate with
            // filter(b => b != null) and simply won't activate.
            console.error('OemMenuService: no business found for destinationId:', destinationId);
          }
        },
        (error) => {
          console.error('OemMenuService: failed to load business for destinationId', destinationId, error);
        }
      );
  }
  getWithHeaders<T>(path: string, opts?: any): Observable<any> {
    path = stripSlash(path);

    // if (opts) {
    //   return this.http
    //     .get(`${determineEnvironment()}${this.quorumApiBase}/${path}`, { ...opts, observe: 'response' })
    //     .pipe(
    //       map((res: any) => {
    //         const headers = new ApiResponseHeaders({
    //           etag: res.headers.get('etag') ? res.headers.get('etag') : null,
    //           total: res.headers.get('x-total') ? parseInt(res.headers.get('x-total')) : null,
    //           totalPages: res.headers.get('x-total-pages') ? parseInt(res.headers.get('x-total-pages')) : null,
    //         });
    //         return { body: res.body, headers: headers };
    //       }),
    //       catchError((err: Response) => catcher(err, path))
    //     );
    // } else {
    //   return this.http.get(`${determineEnvironment()}${this.quorumApiBase}/${path}`, { observe: 'response' }).pipe(
    //     map((res) => {
    //       const headers = new ApiResponseHeaders({
    //         // etag: res.headers.get('etag') ? res.headers.get('etag') : null,
    //         // total: res.headers.get('x-total') ? parseInt(res.headers.get('x-total')) : null,
    //         // totalPages: res.headers.get('x-total-pages') ? parseInt(res.headers.get('x-total-pages')) : null,
    //       });
    //       return { body: res.body, headers: headers };
    //     }),
    //     catchError((err: Response) => catcher(err, path))
    //   );
    // }

    return this.businessId$.pipe(
      filter((businessId) => {
        return businessId != null;
      }),
      take(1),
      switchMap((businessId) => {
        path = stripSlash(path);
        if (opts) {
          return this.http
            .get(`https://${determineEnvironment()}${this.quorumApiBase}/${path}`, { ...opts, observe: 'response' })
            .pipe(
              map((res: any) => {
                const headers = new ApiResponseHeaders({
                  etag: res.headers.get('etag') ? res.headers.get('etag') : undefined,
                  total: res.headers.get('x-total') ? parseInt(res.headers.get('x-total')) : undefined,
                  totalPages: res.headers.get('x-total-pages') ? parseInt(res.headers.get('x-total-pages')) : undefined,
                });
                return { body: res.body, headers: headers };
              }),
              catchError((err: Response) => catcher(err, path))
            );
        } else {
          return this.http
            .get(`https://${determineEnvironment()}${this.quorumApiBase}/${path}`, { observe: 'response' })
            .pipe(
              map((res: any) => {
                const headers = new ApiResponseHeaders({
                  etag: res.headers.get('etag') ? res.headers.get('etag') : undefined,
                  total: res.headers.get('x-total') ? parseInt(res.headers.get('x-total')) : undefined,
                  totalPages: res.headers.get('x-total-pages') ? parseInt(res.headers.get('x-total-pages')) : undefined,
                });
                return { body: res.body, headers: headers };
              }),
              catchError((err: Response) => catcher(err, path))
            );
        }
      })
    );
  }

  getApiUrl() {
    return this.quorumApiBase;
  }

  get<T>(path: string, opts?: any): Observable<any> {
    return this.businessId$.pipe(
      filter((businessId) => {
        return businessId != null;
      }),
      take(1),
      switchMap((businessId) => {
        path = stripSlash(path);
        if (opts) {
          return this.http.get(`https://${determineEnvironment()}${this.quorumApiBase}/${path}`, opts).pipe(
            map((res) => {
              return res;
            }),
            catchError((err: Response) => {
              return catcher(err, path);
            })
          );
        } else {
          return this.http.get(`https://${determineEnvironment()}${this.quorumApiBase}/${path}`).pipe(
            map((res) => res),
            catchError((err: Response) => catcher(err, path))
          );
        }
      })
    );
  }

  getWithoutBusinessId<T>(path: string, opts?: any): Observable<any> {
    path = stripSlash(path);
    if (opts) {
      return this.http.get(`https://${determineEnvironment()}${this.quorumApiBase}/${path}`, opts).pipe(
        map((res) => {
          return res;
        }),
        catchError((err: Response) => {
          return catcher(err, path);
        })
      );
    } else {
      return this.http.get(`https://${determineEnvironment()}${this.quorumApiBase}/${path}`).pipe(
        map((res) => res),
        catchError((err: Response) => catcher(err, path))
      );
    }
  }

  put<T>(path: string, body: any, opts?: any): Observable<any> {
    if (opts) {
      return this.http
        .put(
          `https://${determineEnvironment()}${this.quorumApiBase}/${path}`,
          body ? emptyStringsToNull(body) : undefined,
          opts
        )
        .pipe(
          map((res: any) => {
            if (opts.observe) return res.body;
            else return res;
          }),
          catchError((err) => catcher(err, path))
        );
    } else {
      return this.http
        .put(
          `https://${determineEnvironment()}${this.quorumApiBase}/${path}`,
          body ? emptyStringsToNull(body) : undefined
        )
        .pipe(
          map((res: any) => {
            return res;
          }),
          catchError((err) => catcher(err, path))
        );
    }
  }

  post<T>(path: string, body: any, opts?: any): Observable<any> {
    if (opts) {
      return this.http.post(`https://${determineEnvironment()}${this.quorumApiBase}/${path}`, body, opts).pipe(
        map((res: any) => {
          if (opts.observe) return res.body;
          else return res;
        }),
        catchError((err) => catcher(err, path))
      );
    } else {
      return this.http.post(`https://${determineEnvironment()}${this.quorumApiBase}/${path}`, body).pipe(
        map((res) => res),
        catchError((err) => catcher(err, path))
      );
    }
  }

  // head<T>(path: string, opts?: any): Observable<T> {
  //   path = stripSlash(path);
  //   opts = Object.assign({}, { observe: 'response', responseType: 'json' }, opts);
  //   return this.http.head(`${this.quorumApiBase}/${path}`, opts).pipe(
  //     map((res: any) => {
  //       return res;
  //     }),
  //     catchError((err: Response) => catcher(err, path))
  //   );
  // }
}

function catcher(err: any, path: string): any {
  switch (err.status) {
    case 403:
      return throwError({
        reason: `The requested operation is forbidden.`,
      });
    case 404:
      return throwError({
        reason: `Data for /${path} could not be loaded at this time.`,
      });
    case 500:
      return throwError({
        reason: `Internal server internal. ${err.error.error_description}`,
      });
    case 503:
      const body: any = err.error;
      return throwError({
        reason: body.error_description,
      });
    default:
      return throwError({
        reason: `Unknown error loading /${path}.`,
        statusCode: err.status,
      });
  }
}

/**
 * Fix path if it has a leading slash.
 */
function stripSlash(path: string): string {
  return path.replace(/^\//, '');
}

function emptyStringsToNull(body: any) {
  let bodyCopy = JSON.parse(JSON.stringify(body));
  Object.keys(bodyCopy).forEach((entry: any) => {
    if (bodyCopy[entry] === '') {
      bodyCopy[entry] = null;
    }
  });
  return bodyCopy;
}

function determineEnvironment(): string {
  switch (environment.environment) {
    case 'development':
      return 'development-oem-menu-pricing';
    case 'staging':
      return 'staging-oem-menu-pricing';
    case 'production':
      return 'oem-menu-pricing';
    default:
      return 'staging-oem-menu-pricing';
  }
}
